<script lang="ts" setup>
import type { Category } from '~~/server/api/menu/main'

export interface MenuLinkProps {
    category: Category
    id: string
}

const props = defineProps<MenuLinkProps>()
const activeMenu = useState<string | null>('activeMenu', () => null)
</script>
<template>
  <VNuxtLink
    :id="props.id"
    class="menu-link p-4 p-md-0 justify-content-between transition fs-normal fs-lg-bigger fs-xl-big fw-bolder text-black d-flex align-items-center text-decoration-none text-nowrap"
    :to="props.category.isExternal ? props.category.slug : `/${props.category.slug}`"
    :aria-expanded="activeMenu === props.category.slug"
    :label="`/${props.category.slug}`"
    :target="props.category.isExternal ? '_blank' : '_self'"
    aria-haspopup="true"
  >
    {{ props.category.title }}
    <svg
      v-if="props.category.items.length"
      class="menu-link-icon d-block ms-2 flex-shrink-0 text-secondary transition"
      width="18"
      height="10"
      viewBox="0 0 18 10"
    >
      <path
        d="M8.9999 7.8941L1.60601 0.615417L0.553711 1.68437L8.9999 9.99895L17.4461 1.68437L16.3938 0.615417L8.9999 7.8941Z"
      />
    </svg>
  </VNuxtLink>
</template>
<style lang="scss" scoped>
@import './MenuLink.scss';
</style>
